export default "__VITE_ASSET__DOBASPya__"